import Vue from 'vue'
import VueRouter from 'vue-router'

import "@babel/polyfill"
import 'es6-promise/auto'

import defaultRouter from './routers'
import store from './store'

import VmForm from './vm/form'
import VmHeaderFavorites from './vm/header-favorites'

import commonMixin from './mixins/common.js'

Vue.use(VueRouter)
Vue.config.productionTip = false
Vue.config.devtools = true

// Vue.config.errorHandler = (err, vm, info) => {
//     console.log(err)
//     console.log(info)
// }
// Vue.config.warnHandler = (msg, vm, trace) => {
//     console.log(msg)
//     console.log(trace)
// }
// Vue.config.silent = true

const router = new VueRouter(defaultRouter)


/**
 * HTMLページ上で、自由にjavascriptが配置できるように
 * 範囲の小さいvmに分割する
 */
VmForm.store = store
VmForm.router = router
const formVm = new Vue(VmForm)

VmHeaderFavorites.store = store
VmHeaderFavorites.router = router
const headerFavoritesVm = new Vue(VmHeaderFavorites)

const newItemVm = new Vue({
    store: store,
    router: router,
    el: "#app-new-item",

    mixins: [
        commonMixin,
    ],

    methods: {
        getRecent: function() {
            this.$store.dispatch('recent/getRecent', 3)
        },
    },

    mounted: function() {
        let unsubscribe = this.$store.subscribe((mutation, state) => {
            if (mutation.type == 'recent/setItems') {
                if (typeof triggerByApp !== 'undefined') {
                    for (let f of Object.keys(triggerByApp)) {
                        try {
                            (triggerByApp[f]).execute()
                        } catch (e) {
                            console.log(f)
                            console.log(e)
                        }
                    }
                }
            }
        })
    },


    created: function() {
        this.getRecent()
    }
})

